import "./Logout.scss";

function Logout({ mainState, setLogoutMessageType, setShowConfirmLogout }) {
  const onLogout = () => {
    if (mainState?.period?.periodStatus === "fixtureConfirm") {
      setLogoutMessageType("fixtureConfirm");
    } else {
      setLogoutMessageType("default");
    }
    setShowConfirmLogout(true);
  };

  return (
    <>
      {mainState.authKey && (
        <div className="logout-btn" onClick={onLogout}>
          <i className="fas fa-sign-out-alt"></i>
        </div>
      )}
    </>
  );
}

export default Logout;
